/**
 * aeru UI Animations v4.1
 * 軽量リッチインタラクション
 * jQuery不使用 / scroll listener 1本に統合
 */
(function () {
  'use strict';

  /* ==========================================================================
     Scroll Reveal (IntersectionObserver)
     ========================================================================== */
  function initScrollReveal() {
    var elements = document.querySelectorAll('[data-aeru-reveal]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-aeru-delay') || '0', 10);
          setTimeout(function () { el.classList.add('aeru-revealed'); }, delay);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ==========================================================================
     Stagger Children (IntersectionObserver)
     ========================================================================== */
  function initStaggerReveal() {
    var containers = document.querySelectorAll('[data-aeru-stagger]');
    if (!containers.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var children = entry.target.querySelectorAll('[data-aeru-stagger-child]');
          children.forEach(function (child, i) {
            setTimeout(function () { child.classList.add('aeru-revealed'); }, i * 120);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    containers.forEach(function (c) { observer.observe(c); });
  }

  /* ==========================================================================
     統合 Scroll Handler — 1つの scroll listener で全処理
     ========================================================================== */
  var scrollState = { ticking: false };

  function initScrollEffects() {
    var heroImg = document.querySelector('.aeru-hero__media img');
    var heroOverlay = document.querySelector('.aeru-hero__overlay');
    var scrollHint = document.querySelector('.aeru-hero__scroll-hint');
    var hasHero = !!document.querySelector('.aeru-hero');

    /* --header-height は Dawn の sticky-header JS がセット済み。
       ヒーローの引き上げは CSS で var(--header-height) を参照。 */

    function onScroll() {
      if (scrollState.ticking) return;
      scrollState.ticking = true;

      requestAnimationFrame(function () {
        var scrolled = window.pageYOffset;

        /* Hero parallax */
        if (heroImg && scrolled < 800) {
          heroImg.style.transform = 'translateY(' + (scrolled * 0.15) + 'px)';
        }

        /* Hero text fade */
        if (heroOverlay) {
          heroOverlay.style.opacity = Math.max(0, 1 - scrolled / 350);
        }

        /* Scroll hint — スクロールで非表示 */
        if (scrollHint) {
          if (scrolled > 50) {
            scrollHint.style.opacity = '0';
          } else {
            scrollHint.style.removeProperty('opacity');
          }
        }

        scrollState.ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ==========================================================================
     Card Hover Tilt（タッチ端末では無効）
     ========================================================================== */
  function initCardTilt() {
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('.category-card, .aeru-series-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'translateY(-6px) perspective(600px) rotateX(' + (y * -4) + 'deg) rotateY(' + (x * 4) + 'deg)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ==========================================================================
     Button Ripple
     ========================================================================== */
  function initButtonRipple() {
    if (!document.getElementById('aeru-ripple-style')) {
      var s = document.createElement('style');
      s.id = 'aeru-ripple-style';
      s.textContent = '@keyframes aeru-ripple{to{transform:scale(1);opacity:0;}}';
      document.head.appendChild(s);
    }

    document.querySelectorAll(
      '.aeru-shop-panel__btn, .aeru-brand-story__btn, .aeru-closing-cta__button, .aeru-shop-tab'
    ).forEach(function (btn) {
      btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.addEventListener('click', function (e) {
        var rect = btn.getBoundingClientRect();
        var ripple = document.createElement('span');
        var size = Math.max(rect.width, rect.height) * 2;
        ripple.style.cssText =
          'position:absolute;border-radius:50%;background:rgba(255,255,255,0.3);' +
          'width:' + size + 'px;height:' + size + 'px;' +
          'left:' + (e.clientX - rect.left - size / 2) + 'px;' +
          'top:' + (e.clientY - rect.top - size / 2) + 'px;' +
          'transform:scale(0);animation:aeru-ripple 0.6s ease-out forwards;pointer-events:none;';
        btn.appendChild(ripple);
        setTimeout(function () { ripple.remove(); }, 700);
      });
    });
  }

  /* ==========================================================================
     Smooth Anchor Scroll
     ========================================================================== */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.section-header');
      var offset = header ? header.offsetHeight + 16 : 16;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
    });
  }

  /* ==========================================================================
     FAQ Smooth Accordion
     ========================================================================== */
  function initFAQSmooth() {
    document.querySelectorAll('.aeru-faq__item').forEach(function (detail) {
      var summary = detail.querySelector('summary');
      var content = detail.querySelector('.aeru-faq__answer');
      if (!summary || !content) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (detail.open) {
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(function () {
            content.style.maxHeight = '0';
            content.style.opacity = '0';
          });
          setTimeout(function () { detail.open = false; }, 350);
        } else {
          detail.open = true;
          content.style.maxHeight = '0';
          content.style.opacity = '0';
          requestAnimationFrame(function () {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.style.opacity = '1';
          });
          setTimeout(function () { content.style.maxHeight = 'none'; }, 350);
        }
      });
    });
  }

  /* ==========================================================================
     SP 横スクロール フェードヒント
     ========================================================================== */
  function initScrollFade() {
    document.querySelectorAll('.aeru-scroll-fade').forEach(function (el) {
      var scrollEl = el;
      function check() {
        var atEnd = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 8;
        if (atEnd) {
          el.classList.add('is-scrolled-end');
        } else {
          el.classList.remove('is-scrolled-end');
        }
      }
      scrollEl.addEventListener('scroll', check, { passive: true });
      check();
    });
  }

  /* ==========================================================================
     SP フッターアコーディオン
     ========================================================================== */
  function initFooterAccordion() {
    if (window.innerWidth >= 750) return;

    document.querySelectorAll('.footer .footer-block--menu .footer-block__heading').forEach(function (heading) {
      heading.addEventListener('click', function () {
        var block = heading.closest('.footer-block');
        if (!block) return;
        block.classList.toggle('is-closed');
      });
    });
  }

  /* ==========================================================================
     SP スティッキーカートバー
     ========================================================================== */
  function initStickyCart() {
    var stickyCart = document.querySelector('.aeru-sticky-cart');
    var buyBtn = document.querySelector('.product-form__submit');
    if (!stickyCart || !buyBtn) return;

    /* カートボタンが下方向にスクロールして画面外に出たら表示
       rootMarginを上方向に拡張: 本体ボタンが視野の上端よりさらに上に行く"前"に
       sticky を表示開始することで、スクロール中に「半分見えてる」中間状態を避ける */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var rect = buyBtn.getBoundingClientRect();
        var scrolledPastTop = rect.bottom < 80; /* 本体ボタンの下端が 80px 以内 = ほぼ画面外 */
        if (entry.isIntersecting && !scrolledPastTop) {
          stickyCart.classList.remove('is-visible');
        } else if (scrolledPastTop) {
          stickyCart.classList.add('is-visible');
        } else {
          stickyCart.classList.remove('is-visible');
        }
      });
    }, { threshold: 0, rootMargin: '120px 0px 0px 0px' });

    observer.observe(buyBtn);

    /* スティッキーボタン → 本体のカートボタンをクリック */
    var stickyBtn = stickyCart.querySelector('[data-aeru-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        buyBtn.click();
      });
    }

    /* バリアント変更時にスティッキーカートの価格/在庫を同期 */
    initStickyCartVariantSync(stickyCart);
  }

  function initStickyCartVariantSync(stickyCart) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    function formatJPY(cents) {
      if (typeof cents !== 'number') return '';
      return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant) return;

      var variant = data.variant;
      var priceEl = stickyCart.querySelector('.aeru-sticky-cart__price');
      var btnEl = stickyCart.querySelector('.aeru-sticky-cart__btn');

      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="aeru-sticky-cart__compare">' + formatJPY(variant.compare_at_price) + '</s>';
        }
        html += formatJPY(variant.price);
        priceEl.innerHTML = html;
      }

      if (btnEl) {
        btnEl.disabled = !variant.available;
        if (variant.available) {
          btnEl.innerHTML =
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>カートに入れる';
        } else {
          btnEl.innerHTML = '売り切れ';
        }
      }
    });
  }

  /* ==========================================================================
     Init — 1回だけ実行、重複防止
     ========================================================================== */
  var initialized = false;

  function init() {
    if (initialized) return;
    initialized = true;

    initScrollReveal();
    initStaggerReveal();
    initScrollEffects();
    initCardTilt();
    initButtonRipple();
    initSmoothScroll();
    initFAQSmooth();
    initScrollFade();
    initStickyCart();
    initFooterAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify section reload — Observer 系だけ再初期化 */
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initStaggerReveal();
  });
})();
